export const ADD_OPERATOR_NODE_REQUEST = "ADD_OPERATOR_NODE_REQUEST";
export const ADD_OPERATOR_NODE_SUCCESS = "ADD_OPERATOR_NODE_SUCCESS";
export const ADD_OPERATOR_NODE_FAILURE = "ADD_OPERATOR_NODE_FAILURE";
